export default __webpack_public_path__ + "static/media/main.0d650ee7.gif";